export default __webpack_public_path__ + "static/media/carbon-stablizer-image.f26c800d.png";